<template>
  <div class="map-box">
    <div id="container"></div>
<!--    <div id="panel"></div>-->
  </div>
</template>

<script>
export default {
  data () {
    return {
      map: ''
    }
  },
  props: {
    start: {
      type:Array,
      default:()=>[116.379028, 39.865042]
    },
    end: {
      type:Array,
      default:()=>[106.545486,29.548829]
    },
    center:{
      default:()=>[]
    },
    lineArr: {
      default:()=>[]
    },
    midway:{
      default:()=>[]
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
      this.initroad()
      // this.initMap(this.lineArr)
    })
  },
  methods: {
    init(){
      let that = this;
      // MapLoader().then((AMap) => {
      this.map = new AMap.Map("container", {
        resizeEnable: true,
        center: [106.550464, 29.563761],
        zoom: 13 //地图显示的缩放级别
      });
      console.log(this.center,'center')
      this.marker = new AMap.Marker({
        map: that.map,
        position: that.center,
        icon: "https://webapi.amap.com/images/car.png",
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        angle: -90,
      });

      //   let driving='';
      //   AMap.plugin(["AMap.Driving"],function(){
      //     driving = new AMap.Driving({
      //       map: that.map,
      //       // panel: "panel"
      //   })
      // });
      // console.log(this.start,'this.start')
      // // const waypointsArr=this.midway.map((item,index)=>{
      // //   if(index%2===1) return null
      // //   else return new AMap.LngLat()
      // // })
      // driving.search(new AMap.LngLat(this.start[0], this.start[1]), new AMap.LngLat(this.end[0],this.end[1]),
      //   // {waypoints:[new AMap.LngLat(this.midway[0], this.midway[1])]},
      //   function(status, result) {
      //   if (status === 'complete') {
      //     console.log('绘制驾车路线完成')
      //   } else {
      //     console.log('获取驾车数据失败：' + result)
      //   }
      // });
    },
    //初始化轨迹
    initroad() {
      let that = this
      // 绘制轨迹
      var polyline = new AMap.Polyline({
        map:that.map,
        path: that.lineArr,
        showDir:true,
        strokeColor: "#28F",  //线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6,      //线宽
        // strokeStyle: "solid"  //线样式
      });
      var passedPolyline = new AMap.Polyline({
        map: that.map,
        // path: lineArr,
        strokeColor: "#AF5",  //线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6,      //线宽
        // strokeStyle: "solid"  //线样式
      });
      this.marker.on('moving', function (e) {
        passedPolyline.setPath(e.passedPath);
      });

      this.map.setFitView();
    },
    startAnimation() {
      this.$nextTick(()=>{
        this.marker.moveAlong(this.lineArr, 50000);
      })
    },


    initMap(lineData) {
      // const _this = this
      // 创建地图
      const map = new AMap.Map('container', {
        zoom: 1
      })
      // 加载PathSimplifier，loadUI的路径参数为模块名中 'ui/' 之后的部分
      let AMapUI =new  AMapUI()
      AMapUI.load(['ui/misc/PathSimplifier'], function(PathSimplifier) {
        if (!PathSimplifier.supportCanvas) {
          alert('当前环境不支持 Canvas！')
          return
        }
        // 启动页面
        initPage(PathSimplifier)
      })
      function initPage(PathSimplifier) {
        // 创建组件实例
        var pathSimplifierIns = new PathSimplifier({
          zIndex: 100,
          map: map, // 所属的地图实例
          getPath: function(pathData, pathIndex) {
            console.log('pathData', pathData)
            // 返回轨迹数据中的节点坐标信息，[AMap.LngLat, AMap.LngLat...] 或者 [[lng|number,lat|number],...]
            return pathData.path
          },
          getHoverTitle: function(pathData, pathIndex, pointIndex) {
            // 返回鼠标悬停时显示的信息
            if (pointIndex >= 0) {
              // 鼠标悬停在某个轨迹节点上
              return pathData.name + '，' + pathData.pathNodeName[pointIndex] + '，' + pointIndex + '/' + pathData.path.length
            }
            // 鼠标悬停在节点之间的连线上
            return pathData.name + '，点数量' + pathData.path.length
          },
          renderOptions: {
            keyPointTolerance: 0,
            renderAllPointsIfNumberBelow: 15,
            keyPointStyle: {
              radius: 6, // 点的半径
              fillStyle: '#FF8C00', // 填充色，比如 red, rgb(255,0,0), rgba(0,0,0,1)等
              strokeStyle: '#eeeeee', // 描边色
              lineWidth: 1 // 描边宽度
            },
            // 轨迹线的样式
            pathLineStyle: {
              strokeStyle: 'green',
              lineWidth: 2,
              dirArrowStyle: true
            }
          }
        })
        pathSimplifierIns.setData(lineData)
        // initRoutesContainer(d)
        // function onload() {
        //   pathSimplifierIns.renderLater()
        // }
        // function onerror(e) {
        //   alert('图片加载失败！')
        // }
        // console.log('lineData', lineData)
        let c = {}
        for (let f = 0; f < lineData.length; f++) {
          c = pathSimplifierIns.createPathNavigator(f, // 关联第1条轨迹
            {
              loop: false, // 循环播放
              // speed: 1000000,
              pathNavigatorStyle: {
                autoRotate: false, // 禁止调整方向
                pathLinePassedStyle: null,
                width: 24,
                height: 24,
                // content: PathSimplifier.Render.Canvas.getImageContent(_this.imgUrl_car, onload, onerror),
                strokeStyle: null,
                fillStyle: null
              }
            })
          c.start()
        }
      }
    }

// )}
  }
}
</script>

<style lang="scss" scoped>
.map-box {
  width: 100%;
  height: 100%;
  position: relative;
  #container {
    width: 100%;
    height: 100%;
  }
  #panel {
    display: none;
    position: fixed;
    background-color: white;
    max-height: 90%;
    overflow-y: auto;
    top: 10px;
    right: 10px;
    width: 280px;
  }
  #panel .amap-lib-driving {
    border-radius: 4px;
    overflow: hidden;
  }
}

</style>
